import { ModuleTranslationProvider } from '../../../../contexts/ModuleTranslation'

import Phone from '../Phone'
import translations from '../locales'
import useCart from '../../../../hooks/useCart'
import {
  getFinancedAccessoryGroupFromOffer,
  getMobilityPhoneOffers,
  shouldRenderMobilityPhone
} from '../utils'
import { getFinancedAccessoryGroups } from '../../../../utils/mobility'

const MobilityPhoneContainer = () => {
  const { cart } = useCart()
  if (!shouldRenderMobilityPhone(cart)) return null
  const offers = getMobilityPhoneOffers(cart)
  const financedAccessoryGroups = getFinancedAccessoryGroups(cart)

  return (
    <ModuleTranslationProvider translations={translations} module="mobility-phone">
      {offers.map((mobilityPhoneOffer) => {
        const financedAccessoryGroupFromOffer = getFinancedAccessoryGroupFromOffer(
          mobilityPhoneOffer,
          financedAccessoryGroups
        )

        return (
          <Phone
            key={mobilityPhoneOffer.id}
            cart={cart}
            mobilityPhoneOffer={mobilityPhoneOffer}
            isRemoveButtonHidden={false}
            financedAccessoryGroup={financedAccessoryGroupFromOffer}
          />
        )
      })}
    </ModuleTranslationProvider>
  )
}

export default MobilityPhoneContainer
